import React from "react";
import './LoginDivider.css';

export default function LoginDivider() {
    return (
        <div className="login-divider main-background-color" />
    );
}